export default "__VITE_ASSET__b0a0cda5__"